import { useAuthStore } from '../../../zustand/authentication/use-auth-store'
import * as notificationActions from '../../NotificationMenu/actions'

export const setupNotifications = (data) => {
  if (!data) {
    data = useAuthStore.getState().token
  }

  const headers = {
    Authorization: `${data.token_type} ${data.access_token}`
  }

  notificationActions.getEmailFrequency(headers)
  notificationActions.getSubscriptions(headers)
  notificationActions.checkUnreadNotifications(headers)
}
